import { Button } from 'components/core';
import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { isPersonalField } from 'helpers/kpiBuilder/custom';
import { ColumnKind, CustomColumn } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { FieldPicker } from './FieldPicker';
import { OptionChips } from './OptionChips';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';

const KINDS = [{ id: 'value', label: 'Value' }, { id: 'count', label: 'How many different' }, { id: 'date', label: 'Latest date' }];

// Columns you name yourself, next to the ticked ones. Personal data is refused.
export const TypedColumns = ({ a, patch }: StepProps) => {
  const cols = a.custom.columns;
  const save = (next: CustomColumn[]) => patch({ custom: { ...a.custom, columns: next } });
  const add = () => {
    save([...cols, { label: '', field: '', kind: 'value' }]);
  };
  const remove = (i: number) => () => {
    save(cols.filter((_, j) => j !== i));
  };

  return (
    <BuilderSection title="Other columns" hint="Add a column from any field and give it the heading you want to see. It can show the value, how many different values there are (such as number of competencies), or the latest date. Phone, email and similar personal data are not allowed.">
      {cols.map((c, i) => (
        <div key={i} className="border rounded p-2 mb-2 bg-white">
          <FieldPicker fields={fieldsOf(a.src)} value={c.field} placeholder="Field name" onChange={(field) => save(cols.map((x, j) => (j === i ? { ...x, field } : x)))} />
          <div className="mt-1">
            <OptionChips options={KINDS} selected={[c.kind ?? 'value']} onSelect={(id) => save(cols.map((x, j) => (j === i ? { ...x, kind: id as ColumnKind } : x)))} />
          </div>
          <div className="mt-1">
            <TextBox value={c.label} placeholder="Column heading" onChange={(label) => save(cols.map((x, j) => (j === i ? { ...x, label } : x)))} />
          </div>
          {isPersonalField(c.field) && <div className="alert alert-warning mt-2 mb-0">This looks like personal data, so it will not be shown.</div>}
          <div className="mt-2">
            <Button {...OUTLINE_SMALL} onClick={remove(i)}>
              Remove column
            </Button>
          </div>
        </div>
      ))}
      <Button {...OUTLINE_SMALL} onClick={add}>
        Add a column
      </Button>
    </BuilderSection>
  );
};
